import React from "react";
import { Link } from "react-router-dom";

const options = [
  {
    to: "/math",
    icon: "🧮",
    title: "Math Quiz",
    description: "Practice addition, subtraction, multiplication and division.",
  },
  {
    to: "/capitals",
    icon: "🏛️",
    title: "US State Capital Quiz",
    description: "Pick the correct capital city for a random US state.",
  },
  {
    to: "/map-quiz",
    icon: "🗺️",
    title: "State Map Quiz",
    description: "Click on the correct state on a map of USA.",
  },
];

function HomePage() {
  return (
    <div>
      <div
        style={{
          background: "none",
          boxShadow: "none",
          padding: 0,
          margin: 0,
          minWidth: "unset",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        {options.map((opt) => (
          <Link key={opt.to} to={opt.to} style={{ textDecoration: "none" }}>
            <button
              style={{
                width: "100%",
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                gap: 16,
              }}
            >
              <span style={{ fontSize: "2.2rem", lineHeight: 1 }}>
                {opt.icon}
              </span>
              <span
                style={{
                  background: "none",
                  boxShadow: "none",
                  padding: 0,
                  margin: 0,
                  minWidth: "unset",
                  display: "block",
                }}
              >
                <span
                  style={{
                    display: "block",
                    fontSize: "1.1rem",
                    fontWeight: 700,
                  }}
                >
                  {opt.title}
                </span>
                <span
                  style={{
                    display: "block",
                    fontWeight: 400,
                    fontSize: "0.85rem",
                    opacity: 0.9,
                  }}
                >
                  {opt.description}
                </span>
              </span>
            </button>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default HomePage;
